import { Record, List, Map, fromJS } from 'immutable'
import _ from 'lodash'

import {
    MANAGE_GROUPS_DIALOG_LOADING_TRUE,
    MANAGE_GROUPS_DIALOG_LOADING_FALSE,
    MANAGE_GROUPS_DIALOG_SET_ROWS,
    MANAGE_GROUPS_DIALOG_SET_ROW_LOADING,
} from './constants'

const initialState = Record({
    loading: false,
    rows: List(),
})

export default function manageGroupsDialogReducer(state = initialState(), action = {}) {
    switch (action.type) {
        case MANAGE_GROUPS_DIALOG_LOADING_TRUE: {
            return state.set('loading', true)
        }
        case MANAGE_GROUPS_DIALOG_LOADING_FALSE: {
            return state.set('loading', false)
        }
        case MANAGE_GROUPS_DIALOG_SET_ROWS: {
            const groups = _.get(action, 'data.groups', List())
            const isPresentInGroups = _.get(action, 'data.isPresentInGroups', List())

            const rows = groups.map((g, index) =>
                Map({
                    index,
                    loading: false,
                    inGroup: !!isPresentInGroups.find((preGr) => preGr.get('groupId') === g.get('id')),
                })
            )

            return state.set('rows', fromJS(rows))
        }
        case MANAGE_GROUPS_DIALOG_SET_ROW_LOADING: {
            const index = _.get(action, 'data.index', null)
            const value = _.get(action, 'data.value', false)

            if (_.isNil(index)) return state

            return state.setIn(['rows', index, 'loading'], value)
        }
        default:
            return state
    }
}
